import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sparkles } from "lucide-react";

const SOURCE_WORDS = { build_sheet: "build sheet", photos: "photos" };
const day = (iso) => (iso ? String(iso).slice(0, 10) : "");

// BATCH 4 — the sellable-parts list each AI read already pays for, KEPT and shown here. Read only: it never adds,
// rates or counts a component (confirming items comes with truck components, step C2).
export function TruckSellableList({ list, testid = "truck-sellable" }) {
  const [names, setNames] = useState({});
  useEffect(() => {
    api.get("/component-groups").then(({ data }) => {
      setNames(Object.fromEntries((data.items || []).map((g) => [g.code, g.name])));
    }).catch(() => {});
  }, []);
  if (!list) {
    return <p data-testid={`${testid}-never`} className="text-sm text-slate-500">No AI read has listed sellable parts for this truck yet. The next build-sheet read or photo scan keeps its list here.</p>;
  }
  const reads = Object.entries(list.reads || {});
  return (
    <div data-testid={testid} className="space-y-2">
      <p className="text-xs text-slate-500 flex items-center gap-1.5">
        <Sparkles className="w-3.5 h-3.5 text-[#C76714]" />
        The AI's suggestion only — nobody has confirmed these.{" "}
        {reads.map(([s, r]) => <span key={s} data-testid={`${testid}-read-${s}`}>From the {SOURCE_WORDS[s] || s} read {day(r.at)} ({r.count}).</span>)}
      </p>
      {list.items.length === 0
        ? <p data-testid={`${testid}-none`} className="text-sm text-slate-600">The last read listed nothing it was sure of.</p>
        : (
          <ul className="divide-y divide-slate-100 rounded-lg border border-slate-200">
            {list.items.map((it) => (
              <li key={it.component} data-testid={`${testid}-item-${it.component}`} className="px-3 py-2 text-sm">
                <b className="text-slate-900">{names[it.component] || it.component.replace(/_/g, " ")}</b>
                {it.reason && <span className="text-slate-600"> — {it.reason}</span>}
                <span className="ml-1 font-mono text-[10px] uppercase text-slate-400">{it.sources.map((s) => SOURCE_WORDS[s] || s).join(" + ")}</span>
              </li>
            ))}
          </ul>
        )}
    </div>
  );
}
